var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg412975601606261173(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88C5CC"
    },
    cx: 64,
    cy: 64,
    r: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263740"
    },
    d: "M20,45c0-1.1,0.9-2,2-2h19c1.1,0,2-0.9,2-2v-3c0-1.1,0.9-2,2-2h60c1.1,0,2,0.9,2,2v53 c0,1.1-0.9,2-2,2H22c-1.1,0-2-0.9-2-2V45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2C33"
    },
    d: "M105,36h-4c1.1,0,2,0.9,2,2v53c0,1.1-0.9,2-2,2h4c1.1,0,2-0.9,2-2V38C107,36.9,106.1,36,105,36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 41,
    style: {
      fill: "#E16B5A"
    },
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 37,
    style: {
      fill: "#CCCCCC"
    },
    width: 13,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M107,49V38c0-1.1-0.9-2-2-2H45c-1.1,0-2,0.9-2,2v3c0,1.1-0.9,2-2,2H22c-1.1,0-2,0.9-2,2v4H107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M105,36h-4c1.1,0,2,0.9,2,2v11h4V38C107,36.9,106.1,36,105,36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 38,
    style: {
      fill: "#406A80"
    },
    width: 20,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 40,
    style: {
      fill: "#C2E2F2"
    },
    width: 16,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 38,
    style: {
      fill: "#CCCCCC"
    },
    width: 20,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 40,
    style: {
      fill: "#E6E6E6"
    },
    width: 16,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 42,
    style: {
      fill: "#F5F5F5"
    },
    width: 16,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 63,
    cy: 70,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M63,85c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S71.271,85,63,85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M63,83c-7.168,0-13-5.832-13-13s5.832-13,13-13s13,5.832,13,13S70.168,83,63,83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#406A80"
    },
    d: "M63,77c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S66.859,77,63,77z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D7F99"
    },
    cx: 60,
    cy: 67,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D7F99"
    },
    cx: 61,
    cy: 71,
    r: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg412975601606261173);
export default __webpack_public_path__ + "static/media/412975601606261173.b946f63ff2fcf6c225f75971233dd98f.svg";
export { ForwardRef as ReactComponent };